import { UIText1, UIText2 } from '@cian/ui-kit';
import { numberToPrettyString } from '@cian/utils';
import * as React from 'react';

import * as styles from './PromotionTooltipContent.css';
import { type IPromotionVas } from './utils/getPromotionVasList';

interface IPromotionTooltipContentProps {
  items: IPromotionVas[];
  auctionBidRubles: number | null;
  learnMoreUrl?: string;
}

const getAuctionBidText = (auctionBidRubles: number): string =>
  `Чтобы опередить это объявление, опубликуйте объявление со ставкой больше ${numberToPrettyString(
    auctionBidRubles,
  )} ₽.`;

const handleLearnMoreLinkClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
  event.stopPropagation();
};

export const PromotionTooltipContent = ({ items, auctionBidRubles, learnMoreUrl }: IPromotionTooltipContentProps) => {
  const normalizedLearnMoreUrl = learnMoreUrl?.trim();
  const isAuctionBidTextVisible = auctionBidRubles !== null;
  const isLearnMoreLinkVisible = Boolean(normalizedLearnMoreUrl);

  return (
    <div className={styles['root']}>
      <div className={styles['items']}>
        <UIText1 fontWeight="bold">Действуют услуги</UIText1>
        {items.map(item => (
          <div className={styles['item']} key={item.name}>
            <UIText2 fontWeight="bold" color="decorative-deeporange-vas">
              {item.name}
            </UIText2>
            <UIText2>{item.description}</UIText2>
          </div>
        ))}
      </div>
      {isAuctionBidTextVisible && (
        <div className={styles['auction-bid']}>
          <UIText2>{getAuctionBidText(auctionBidRubles)}</UIText2>
        </div>
      )}
      {isLearnMoreLinkVisible && (
        <div className={styles['learn-more']}>
          <UIText2>
            <a
              className={styles['link']}
              href={normalizedLearnMoreUrl}
              rel="noreferrer noopener"
              target="_blank"
              onClick={handleLearnMoreLinkClick}
            >
              Узнать подробнее
            </a>
          </UIText2>
        </div>
      )}
    </div>
  );
};
